import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Bautagebuch() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [berichte, setBerichte] = useState([]);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    api.get('/bautagebuecher').then(r => setBerichte(r.data)).catch(() => {});
  }, []);

  const deleteBericht = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Bautagebuch wirklich löschen?')) return;
    await api.delete(`/bautagebuecher/${id}`).catch(() => {});
    setBerichte(berichte.filter(b => b.id !== id));
  };

  const filtered = berichte.filter(b =>
    !filter || b.baustelle_name?.toLowerCase().includes(filter.toLowerCase()) || b.datum?.includes(filter)
  );

  const badge = s => {
    if (s === 'fertig') return <span className="badge badge-blue">Fertig</span>;
    if (s === 'entwurf') return <span className="badge badge-amber">Entwurf</span>;
    return <span className="badge badge-grey">{s}</span>;
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Bautagebuch</div>
          <div className="page-sub">{berichte.length} Einträge gesamt</div>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/bautagebuch/erstellen')}>+ Neuer Eintrag</button>
      </div>
      <div className="card">
        <div className="card-head">
          <input className="form-input" placeholder="Suchen nach Baustelle, Datum…" value={filter}
            onChange={e => setFilter(e.target.value)} style={{ width: 280 }} />
        </div>
        {filtered.length === 0 ? (
          <div className="empty">
            <div className="empty-icon">📋</div>
            <h3>Keine Einträge</h3>
            <p>Noch keine Bautagebücher angelegt.</p>
          </div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Datum</th>
                  <th>Baustelle</th>
                  <th>Bauleiter</th>
                  <th>Erstellt von</th>
                  <th>Status</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(b => (
                  <tr key={b.id} onClick={() => navigate(`/bautagebuch/${b.id}/ansicht`)} style={{ cursor: 'pointer' }}>
                    <td style={{ fontFamily: 'monospace', fontSize: 12 }}>
                      {b.datum ? new Date(b.datum).toLocaleDateString('de-DE') : '–'}
                    </td>
                    <td style={{ fontWeight: 500 }}>{b.baustelle_name || '–'}</td>
                    <td>{b.bauleiter || '–'}</td>
                    <td>{b.user_name || '–'}</td>
                    <td>{badge(b.status)}</td>
                    <td>
                      <button className="btn btn-secondary btn-sm"
                        onClick={e => { e.stopPropagation(); navigate(`/bautagebuch/${b.id}/ansicht`); }}>
                        Öffnen
                      </button>
                    </td>
                    {user?.role === 'admin' && (
                      <td>
                        <button className="btn btn-danger btn-sm" onClick={e => deleteBericht(b.id, e)}>🗑</button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
